import { parseISO } from "date-fns";
import { object, string, date } from "yup";
import { Fragments } from "requests";

export const getValidation = (initialValues?: Fragments.StoreExamNotes) => {
  const nullableString = string()
    .default("")
    .nullable();

  const validationSchema = object().shape({
    additionalNotes: nullableString,
    vaccines: nullableString,
    bloodwork: nullableString,
    previousSurgery: nullableString,
    allergies: nullableString,
    treatmentPlan: nullableString,
    lastMealAt: date().nullable(),
    patientPersonalItems: nullableString
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({
      additionalNotes: initialValues?.additionalNotes || "",
      vaccines: initialValues?.vaccines || "",
      bloodwork: initialValues?.bloodwork || "",
      previousSurgery: initialValues?.previousSurgery || "",
      allergies: initialValues?.allergies || "",
      treatmentPlan: initialValues?.treatmentPlan || "",
      patientPersonalItems: initialValues?.patientPersonalItems || "",
      lastMealAt: initialValues?.lastMealAt
        ? parseISO(initialValues.lastMealAt)
        : null
    })
  };
};
